import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {MixedObject} from '@core/interfaces/mixed-object';

import { Observable } from 'rxjs';
import { ApiUrlService } from '../common/api-url.service';
import { ClientService } from '@core/services/client/client.service';

@Injectable({
  providedIn: 'root'
})
export class ApiReCaptchaService {
  private apiUrl: string = this.apiUrlService.getApiUrl() + 'client/re-captcha/';

  constructor(private httpClient: HttpClient,
              private apiUrlService: ApiUrlService,
              private clientService: ClientService,
  ) {
  }

  verify(token: string): Observable<MixedObject> {
    const url = this.apiUrl + 'verify';
    return this.httpClient.post(url, {token});
  }

  async verifyRecaptchaIfNeeded(): Promise<boolean> {
    if (!this.clientService.client) {
      return true;
    }

    return new Promise((resolve) => {
      const googleRecaptcha = (window as MixedObject).grecaptcha;

      if (!googleRecaptcha) {
        resolve(true);
        return;
      }

      googleRecaptcha.ready(() => {
        const {recaptchaSiteKey} = this.clientService.client.websiteSettings;

        if (!recaptchaSiteKey) {
          resolve(true);
          return;
        }

        googleRecaptcha.execute(recaptchaSiteKey, {action: 'submit'})
          .then((token: string) => {
            this.verify(token).subscribe(res => {
              resolve(res.result);
            });
          })
          .catch(() => {
            resolve(true);
          });
      });
    });

  }
}
